// extracted by mini-css-extract-plugin
export default {"main":"d63c52c7ed _2b15d49664 _37a6550d26 c74cca9d98","title":"f2816b0451"};